import HTML5 from 'react-dnd-html5-backend';
import {DragDropContext} from 'react-dnd';

export default DragDropContext(HTML5);
